var map = {
	"./$GMUSIC-icon.png": 1964,
	"./BAT-icon.png": 1965,
	"./BTC-icon.png": 1966,
	"./BXC-icon.png": 1967,
	"./CC-icon.png": 651,
	"./DistTest-icon.png": 1968,
	"./ETH-icon.png": 1969,
	"./ETIME-icon.png": 1970,
	"./ETIME[GYRI]-icon.png": 1971,
	"./GALA-icon.png": 1336,
	"./GALA[ETH]-icon.png": 1972,
	"./GALA[GYRI]-icon.png": 1973,
	"./GUSDC-icon.png": 1974,
	"./GUSDT-icon.png": 1975,
	"./GWBTC-icon.png": 1976,
	"./GWETH-icon.png": 1977,
	"./MTRM-icon.png": 1978,
	"./NODETESTCOIN-icon.png": 1979,
	"./SILK-icon.png": 1980,
	"./SILK[GYRI]-icon.png": 1981,
	"./SUPER-icon.png": 1982,
	"./TANK-icon.png": 1983,
	"./TCTESTCOIN-icon.png": 1984,
	"./TEST-icon.png": 1985,
	"./TOWN-icon.png": 1986,
	"./USD-icon.png": 1101,
	"./USDC-icon.png": 1987,
	"./USDT-icon.png": 1988,
	"./WBTC-icon.png": 1989,
	"./WETH-icon.png": 1990,
	"./coinpayments-icon.png": 1991,
	"./mastercard-icon.png": 649,
	"./simplex-icon.png": 1348,
	"./visa-icon.png": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;